<section class="container-fluid footer-bottom-bar">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="card border-0 shadow footer-card p-lg-5 p-3">
                    <div class="card-body">
                        <div class="d-flex flex-column text-center">
                            <h2
                                [innerHTML]="
                                    'info-register-header' | cmsText | async
                                "
                            ></h2>
                            <h5
                                [innerHTML]="
                                    'info-register-header-subtitle'
                                        | cmsText
                                        | async
                                "
                            ></h5>
                        </div>
                        <div
                            class="mt-3 d-flex flex-column flex-lg-row justify-content-between"
                        >
                            <div class="container">
                                <div class="row mt-3">
                                    <div
                                        class="col-12 col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-6 offset-md-3 mb-2 mb-md-0 px-md-0"
                                    >
                                        <app-register-btns></app-register-btns>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
